export default __webpack_public_path__ + "static/media/search_icon.cd255964.svg";